import axios from 'axios';
import qs from 'qs';
import Session from '@/Session';

export const api = axios.create({
  baseURL: process.env.BACKEND_URL,
  headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache', 'Expires': '-1' },
  paramsSerializer(params) {
    return qs.stringify(params, { arrayFormat: 'brackets' });
  },
});

api.interceptors.response.use(response => response.data, err => Promise.reject(err));

api.interceptors.request.use((config) => {
  const accessToken = Session.getAccessToken();
  const resetToken = Session.getResetToken();
  let newConfig = config;

  if ((accessToken && accessToken.id) || (resetToken && resetToken.id)) {
    newConfig = Object.assign(newConfig,
      { headers: config.headers || {} },
      { headers: Object.assign( { 'Cache-Control': 'no-cache' }, { 'Pragma': 'no-cache'}, { Authorization: accessToken ? accessToken.id : resetToken.id }) },
    );
  }

  return newConfig;
}, err => Promise.reject(err));

export default api;



// WEBPACK FOOTER //
// ./src/api.js